import { createComponent } from '@carvana/merch-components';
import styles from './VehicleTile.module.css';

export const Wrapper = createComponent('a', {
  className:
    'relative grid w-[332px] grid-rows-[177px_1fr] rounded-[6px] border border-grey-2 bg-white text-blue-7 hover:shadow'
});

export const DetailsWrapper = createComponent('div', {
  className: 'grid grid-rows-[auto_72px_1fr] px-16 py-12 text-blue-7'
});

export const DetailsGrid = createComponent('div', {
  className: 'grid grid-rows-[12px_24px_20px] gap-4'
});

export const YearMakeModel = createComponent('span', {
  className: `${styles['year-make-model']} truncate font-bold`
});

export const TrimAndMileage = createComponent('div', {
  className: 'tl-body-s'
});

export const Price = createComponent('span', {
  className: `${styles.price} flex-1 font-bold`
});

export const LowerSectionWrapper = createComponent('div', {
  className: 'mt-4 grid grid-cols-1 grid-rows-[20px] gap-4'
});

export const LowerSectionItem = createComponent('div', {
  className: 'flex items-center gap-8'
});

export const UpperSection = createComponent('div', {
  className: 'relative'
});

export const Image = createComponent('img', {
  className: 'rounded-t-md object-cover'
});

export const Overlay = createComponent('div', {
  className:
    'grid-column-1 grid-row-1 pointer-events-none absolute right-0 top-0 z-1 flex justify-between'
});
